import React, { Component } from "react";
import { Link } from "react-router-dom";

class CallCenterPhoneSection extends Component {
  render() {
    return (
      <div className="main-content">
        <div className="ccpa-wrapper">
          <div className="component-section">
            <div className="section-top position-center form-section">
              <h1>
                <u>** 7-Eleven Call Center DSAR Intake Form ** </u>
              </h1>
              <p>
                <br></br>
              </p>
              <p>FOR INTERNAL USE ONLY - DO NOT SHARE THIS LINK </p>
              <p>
                <br></br>
              </p>
              <p>
                Agents, please use this form to submit requests relating to
                consumers’ personal data held with 7-Eleven, Inc.
              </p>
              <p>
                <br></br>
              </p>
              <p>
                If a consumer is interested in submitting a deletion request,
                make sure they are aware that deleting their personal
                information from our records will result in the permanent loss
                of 7-Eleven account(s) linked to the information they’ve
                provided including, but not limited to transaction history,
                rewards earned and other linked information.
              </p>
              <p>
                <br></br>
              </p>
              <p>
                Please use this form for customers that have a phone-only
                account. They will not use their email to login to the 7-Eleven
                loyalty applications.
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default CallCenterPhoneSection;
